import React from "react";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { Card } from "@UI/Components/Card/Card";
import { Text } from "@UI/Components/Text/Text";
import { Icon } from "@UI/Components/Icon/Icon";
import { WhiteSuperTalentBadge } from "@UI/Components/Icons/WhiteSuperTalent";
import { Flex } from "@UI/Components/Flex/Flex";
import { ArrowRight } from "@UI/Components/Icons/ArrowRight";
import { Bold } from "@UI/Components/Bold/Bold";
import { useCurrentUser } from "@modules/Authentication/hooks/useCurrentUser";
import { useServiceProvider } from "@modules/ServiceProviders/hooks/useServiceProvider";
import useThemeToken from "@UI/hooks/useThemeToken";
import messages from "./messages";

export const SuperTalentCTA = ({ onClick }: { onClick: () => void }) => {
  const { currentUser } = useCurrentUser({
    includes: ["serviceProvider"],
  });

  const { serviceProvider } = useServiceProvider(
    currentUser?.serviceProvider?.id
  );

  const pink500 = useThemeToken("colors", "pink.500");
  const orange500 = useThemeToken("colors", "orange.500");
  const pink600 = useThemeToken("colors", "pink.600");
  const orange600 = useThemeToken("colors", "orange.600");

  return (
    <Card
      shadow={null}
      paddingX={["3", "3", "4"]}
      paddingY={["3", "3", "3"]}
      background={`linear-gradient(96.51deg, ${pink500} 0%, ${orange500} 99.87%);`}
      _hover={{
        background: `linear-gradient(96.51deg, ${pink600} 0%, ${orange600} 99.87%);`,
      }}
      w="fit-content"
      cursor="pointer"
      mt={{ base: 5, md: 8 }}
      onClick={onClick}
    >
      <Flex alignItems="center" justifyContent="space-between">
        <Icon
          as={WhiteSuperTalentBadge}
          display="block"
          marginRight={3}
          width="4"
          height="4"
        />
        <Text fontSize="md" textAlign="left" color="white" mb="0">
          {serviceProvider?.superTalent && (
            <FormattedMessage
              {...messages.youAreSuperTalentInfos}
              values={{
                whiteBold: () => (
                  <Bold color="white">
                    <FormattedMessage {...messages.youAreSuperTalent} />
                  </Bold>
                ),
              }}
            />
          )}
          {!serviceProvider?.superTalent && (
            <FormattedMessage
              {...messages.discoverAdvantages}
              values={{
                whiteBold: () => (
                  <Bold color="white">
                    <FormattedMessage {...messages.superTalentName} />
                  </Bold>
                ),
              }}
            />
          )}
        </Text>
        <Icon
          as={ArrowRight}
          display="block"
          marginLeft={3}
          width="4"
          height="4"
          color="white"
        />
      </Flex>
    </Card>
  );
};
